// change-language.js
import * as bootstrap from 'bootstrap';
const supportedLanguages = ['ca'];

window.changeLanguage = function(language) {
    let currentUrl = window.location.href;
    localStorage.setItem('languageSelected', 'true'); // Store the user's choice

    // Check if the current URL already includes any of the supported languages
    const hasSupportedLanguage = supportedLanguages.some(lang => currentUrl.includes(`/${lang}/`));
    
    // 'es' don't use /lang/, so we don't need ot take any action
    if (language === 'es' && !hasSupportedLanguage) {
        return;
    }

    // Get current URL and hash
    let urlParts = currentUrl.split('#');
    let baseUrl = urlParts[0];
    let hash = urlParts[1] ? '#' + urlParts[1] : '';
    // Check if the language is already in the URL
    if (!baseUrl.includes(`/${language}`)) {
        // Construct new URL
        let newUrl;
        if (language === 'es') {
            // Spanish selected, remove language code if present
            newUrl = baseUrl.replace(/\/[a-z]{2}\//, '/') + hash;
        } else {
            // Other language selected, add language code
            newUrl = baseUrl.replace(/(https?:\/\/[^\/]+\/?)/, `$1${language}/`) + hash;
        }

        // Redirect to the new URL
        window.location.href = newUrl;
    }
};

window.onload = () => {
    // Check if the language has already been selected
    if (!localStorage.getItem('languageSelected')) {
        const languageModalElement = document.getElementById('languageModal');
        const languageModal = new bootstrap.Modal(languageModalElement);
        languageModal.show();
    }
};